import Newsletter from 'themes/base/components/shop/Newsletter'

export default {
  extends: Newsletter,
}
